import React from 'react'
import { ReactComponent as RocketLaunch } from '../../../Assets/img/Profile/rocketlunch.svg';
// import { Image } from '@mui/icons-material';

const Finance = () => {
  return (
    <div className='finance-container m-5 d-flex flex-column justify-content-center align-items-center min-vh-50'>


      <div className="text-center mb-4">
        {/* <img src={ConfettiArch} alt="Confetti Arch" style={{ width: '30px', height: 'auto', position: 'absolute', top: "300px", left: "200px" }} /> */}
        <RocketLaunch width={150} height={150} />
        {/* <img src={ConfettiCircle} alt='confetticircle' style={{ width: "30px", position: "absolute", top: "410px", left: "740px" }} />
        <img src={ConfettiDot} alt='confetticircle' style={{ width: "10px", position: "absolute", top: "600px", left: "240px" }} />
        <img src={ConfettiRibbon} alt='confettiRibbon' style={{ width: "30px", position: "absolute", top: "300px", left: "820px" }} /> */}

      </div>


      <p className='finance-txt text-center'>Coming Soon...</p>
      <p className='fs-5 m-0 text-center' style={{ color: "rgb(0, 0, 0, 0.6) " }}>Are you Ready to get something new from us.</p>
      <p className='text-center' style={{ color: "rgb(0, 0, 0, 0.6) " }}>Stay tuned for something amazing.</p>
    </div>
  )
}

export default Finance;